export const generateDropdownButtonClassNames = ({ active, shown }) =>
  `${active ? 'active ' : ''}${shown ? 'open' : 'closed'}`;

export const generateDropdownId = ({ htmlIdPrefix }) =>
  `${htmlIdPrefix}-dropdown`;
